import { ping } from 'api/auth'
import useSWR from 'swr'

import useUser from './useUser'

const SESSION_KEEP_ALIVE_SWR_KEY = 'auth/session-keepalive'
const KEEP_ALIVE_INTERVAL_MS = 60 * 1000

export default function useKeepSessionAlive() {
    const { isLoggedIn } = useUser()
    let key: string | null = null
    let refreshInterval = 0

    if (isLoggedIn) {
        key = SESSION_KEEP_ALIVE_SWR_KEY
        refreshInterval = KEEP_ALIVE_INTERVAL_MS
    }

    useSWR<boolean | null>(key, ping, {
        refreshInterval,
        dedupingInterval: KEEP_ALIVE_INTERVAL_MS,
        // Preserve the heartbeat in background tabs and across connectivity changes.
        refreshWhenHidden: true,
        refreshWhenOffline: true,
        // The first heartbeat remains delayed, with no extra event-driven requests.
        revalidateOnMount: false,
        revalidateIfStale: false,
        fallbackData: null,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
    })
}
